// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ngw-gui-mayout-area {
  display: grid;
  gap: 1em;
}
.ngw-gui-mayout-area.pad {
  padding: 1em;
}
.ngw-gui-mayout-area > div.lot > label {
  display: inline-flex;
  gap: 0.5ex;
}
.ngw-gui-mayout-area > div.lot > label > div.error {
  color: var(--error);
}
.ngw-gui-mayout-area.label-left > div.lot {
  display: contents;
}
.ngw-gui-mayout-area.label-left > div.lot > label {
  align-self: center;
  margin-right: -0.33em;
  min-width: 4em;
}
.ngw-gui-mayout-area.label-left > div.lot > label > div:first-child {
  flex: 1;
}
.ngw-gui-mayout-area.label-top > div.lot {
  display: flex;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/gui/nodepkg/mayout/Area.less"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,QAAA;AACJ;AACI;EACI,YAAA;AACR;AANA;EAUY,oBAAA;EACA,UAAA;AADZ;AAVA;EAcgB,mBAAA;AADhB;AAMI;EACI,iBAAA;AAJR;AAGI;EAIQ,kBAAA;EACA,qBAAA;EACA,cAAA;AAJZ;AAFI;EASY,OAAA;AAJhB;AASI;EACI,aAAA;EACA,sBAAA;AAPR","sourcesContent":[".ngw-gui-mayout-area {\n    display: grid;\n    gap: 1em;\n\n    &.pad {\n        padding: 1em;\n    }\n\n    > div.lot {\n        > label {\n            display: inline-flex;\n            gap: 0.5ex;\n\n            > div.error {\n                color: var(--error);\n            }\n        }\n    }\n\n    &.label-left > div.lot {\n        display: contents;\n\n        > label {\n            align-self: center;\n            margin-right: -0.33em;\n            min-width: 4em;\n\n            > div:first-child {\n                flex: 1;\n            }\n        }\n    }\n\n    &.label-top > div.lot {\n        display: flex;\n        flex-direction: column;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
